module.exports = __webpack_public_path__ + "static/ceo2-6c9b9633deef4937944718543ad9e248.jpg";